// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'
import PayLoad from '../@core/auth/jwt/payload'

// ** UseJWT import to get config
import useJwt from '@src/auth/jwt/useJwt'

const config = useJwt.jwtConfig

const initialUser = () => {
  const item = window.localStorage.getItem('userData')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {}
}

export const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    userData: initialUser()
  },
  reducers: {
    handleLogin: (state, action) => {
      const payload = PayLoad(action.payload.access_token)

      state.userData = payload

      state[config.storageTokenKeyName] = action.payload.access_token
      state[config.storageRefreshTokenKeyName] = action.payload.refresh_token
      localStorage.setItem(
        'userData',
        JSON.stringify({
          ...payload
        })
      )
      localStorage.setItem(config.storageTokenKeyName, JSON.stringify(action.payload.access_token))
      localStorage.setItem(config.storageRefreshTokenKeyName, JSON.stringify(action.payload.refresh_token))
    },
    handleLogout: (state) => {
      state.userData = {}
      state[config.storageTokenKeyName] = null
      state[config.storageRefreshTokenKeyName] = null
      // ** Remove user, accessToken & refreshToken from localStorage
      localStorage.removeItem('userData')
      localStorage.removeItem(config.storageTokenKeyName)
      localStorage.removeItem(config.storageRefreshTokenKeyName)
      localStorage.removeItem('configApp')
    }
  }
})

export const { handleLogin, handleLogout } = authSlice.actions

export default authSlice.reducer
